import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {toggleAction} from "../../redux/store";
import shootingPoint from "../../../core/json/shootingPoint.json";
import callPeerRemoteModule from "../../../core/utils/callPeerRemoteModule";


const useTargetCamera = () => {
  const dispatch = useDispatch();
  const camera = useSelector(state => state.toggle.camera);

  const {hotspot, connectMode} = useSelector(state => ({
    hotspot: state.toggle.hotspot,
    connectMode: state.theme.connectMode
  }),shallowEqual);







  const findShootingPoint = (target) => {
    return shootingPoint[target]
  }


  const shootingPointChange = async (stepData, target) => {
    const peer = await callPeerRemoteModule(connectMode);
    let targetCameraType = stepData && stepData.cameraType;
    let targetCameraCode = stepData && stepData.cameraCode;

    if (!stepData.cameraType && target) {
      if (findShootingPoint(target)) {
        targetCameraType = findShootingPoint(target).cameraType;
        targetCameraCode = findShootingPoint(target).cameraCode;
      }
    }

    if (!targetCameraType && !targetCameraCode) {
      return;
    }

    if (camera.currentCameraType === targetCameraType && camera.currentCameraCode === targetCameraCode) {
      return;
    }

    if(peer) {
      peer.conn.sendData("camera:change", [hotspot, targetCameraType, targetCameraCode, camera.currentCameraType === targetCameraType]);
    } else if(!peer) {
      if(targetCameraCode === "TRUNK") {
        window && window.postMessage({
          msg: "camera:change",
          data: [hotspot, targetCameraType, targetCameraCode, camera.currentCameraType === targetCameraType]
        }, "*");
      } else {
        window && window.postMessage({
          msg: "camera:change",
          data: [hotspot, targetCameraType, targetCameraCode, camera.currentCameraType === targetCameraType]
        }, "*");
      }
    }

    dispatch(toggleAction.setToggle({
      key: "camera",
      value: {currentCameraType: targetCameraType, currentCameraCode: targetCameraCode}
    }));
  }



  return {shootingPointChange}
}

export default useTargetCamera;
